import { render, staticRenderFns } from "./FaqCategoryCreateModal.vue?vue&type=template&id=c97fb658&"
import script from "./FaqCategoryCreateModal.vue?vue&type=script&lang=js&"
export * from "./FaqCategoryCreateModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports